import IconDark from '@mui/icons-material/DarkModeOutlined'
import IconLight from '@mui/icons-material/LightModeOutlined'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Switch from '@mui/material/Switch'
import Tooltip from '@mui/material/Tooltip'
import { useColorScheme } from '@mui/material/styles'

import { darkMode, lightMode } from './colorMode'

type Props = {
    mini?: boolean
}

export default function ColorModeToggle({ mini = false }: Props) {
    const { mode, setMode } = useColorScheme()
    const isDark = mode === darkMode
    const label = isDark ? 'Light mode' : 'Dark mode'
    const icon = isDark ? <IconLight /> : <IconDark />

    const toggle = () => setMode(isDark ? lightMode : darkMode)

    if (mini) {
        return (
            <Tooltip title={label} placement="right">
                <ListItemButton
                    onClick={toggle}
                    aria-label={label}
                    sx={{ color: 'inherit', justifyContent: 'center' }}
                >
                    <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                        {icon}
                    </ListItemIcon>
                </ListItemButton>
            </Tooltip>
        )
    }

    return (
        <ListItemButton onClick={toggle} aria-label={label} sx={{ color: 'inherit' }}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary="Dark mode" slotProps={{ primary: { noWrap: true } }} />
            <Switch edge="end" size="small" checked={isDark} tabIndex={-1} disableRipple />
        </ListItemButton>
    )
}
